import { Bolt, Shield, Check } from './Icons';

export default function Hero({ company }) {
  return (
    <section className="hero" id="top">
      <div className="hero__glow" aria-hidden="true" />
      <div className="hero__grid" aria-hidden="true" />
      <div className="container hero__inner">
        <div className="hero__copy">
          <span className="pill">
            <Bolt width={14} height={14} />
            {company.contact?.country || 'Kenya'} · CCTV · Wi-Fi · Digital Tools
          </span>
          <h1 className="hero__title">
            {company.tagline || 'Security, connectivity & smart digital tools'}
          </h1>
          <p className="hero__lead">{company.about}</p>

          <div className="hero__actions">
            <a href="#contact" className="btn btn--primary">
              Get a free quote
            </a>
            <a href="#tools" className="btn btn--ghost">
              Explore digital tools
            </a>
          </div>

          <ul className="hero__trust">
            <li>
              <Check width={16} height={16} /> {company.warranty
                ? '2-year hardware warranty'
                : 'Trusted installations'}
            </li>
            <li>
              <Check width={16} height={16} /> Secure remote access
            </li>
            <li>
              <Check width={16} height={16} /> Business-grade support
            </li>
          </ul>
        </div>

        <div className="hero__panel" aria-hidden="true">
          <div className="hero__card">
            <div className="hero__card-head">
              <Shield width={22} height={22} />
              <span>Live protection</span>
              <span className="dot dot--live" />
            </div>
            <div className="hero__stat-row">
              <div className="hero__stat">
                <strong>16</strong>
                <span>cameras deployed</span>
              </div>
              <div className="hero__stat">
                <strong>10TB</strong>
                <span>secure storage</span>
              </div>
            </div>
            <div className="hero__bars">
              <span style={{ height: '40%' }} />
              <span style={{ height: '70%' }} />
              <span style={{ height: '55%' }} />
              <span style={{ height: '90%' }} />
              <span style={{ height: '65%' }} />
              <span style={{ height: '80%' }} />
            </div>
            <div className="hero__card-foot">
              <span className="dot dot--live" /> All zones online
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
